import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {Appointment} from '../../../../shared/types/person/appointment';
import {AddAppointmentPersonService} from '../../../../shared/services/appointment/add-appointment-person.service';
import {SelectItem} from 'primeng/api';
import {ContactData} from '../../../../shared/types/organization/contact-data';

@Component({
  selector: 'wsd-add-appointment-person',
  templateUrl: './add-appointment.component.html',
  styleUrls: ['./add-appointments.component.css']
})
export class AddAppointmentComponent implements OnInit {

  @Output()
  onSave = new EventEmitter<any>();

  @Input()
  emails: ContactData[] = [];

  appointmentForm: UntypedFormGroup;
  regionFilter: UntypedFormGroup;

  appointment: Appointment;

  emailItems: SelectItem[] = [{label: '', value: ''}];

  display: boolean = false;

  constructor(private addAppointmentService: AddAppointmentPersonService,
              private fb: UntypedFormBuilder) {
  }

  ngOnInit() {
    this.regionFilter = this.fb.group({
      region: []
    });
    this.appointmentForm = this.fb.group({
      standardTitle: ['', Validators.required],
      organization: ['', Validators.required],
      email: [''],
      official: [false],
      directoryTitle: [''],
      directorySecondTitle: ['']
    });
    this.addAppointmentService.messageSent$.subscribe(
      (data: any) => this.init(data)
    );
  }

  private init(appointment: Appointment) {
    this.appointment = appointment;
    this.appointmentForm.reset();
    this.appointmentForm.patchValue(appointment);
    if (!this.appointmentForm.get('email').value) {
      this.appointmentForm.get('email').setValue(this.getPreferredEmail());
    }
    this.display = true;


    this.emailItems = [{label: '', value: ''}];
    this.emailItems = this.emailItems.concat(this.emails.map(email => {
      return {label: email.value, value: email.value};
    }));
  }

  private getPreferredEmail() {
    const foundEmail = this.emails.find(email => email.preferred);
    return typeof foundEmail !== 'undefined' ? foundEmail.value : '';
  }

  save() {
    this.appointmentForm.markAsDirty();

    Object.keys(this.appointmentForm.controls).forEach(key => {
      this.appointmentForm.get(key).markAsDirty();
    });

    if (this.appointmentForm.invalid) {
      return;
    }

    this.appointment.standardTitle = this.appointmentForm.get('standardTitle').value;
    this.appointment.directoryTitle = this.appointmentForm.get('directoryTitle').value;
    this.appointment.directorySecondTitle = this.appointmentForm.get('directorySecondTitle').value;
    this.appointment.organization = this.appointmentForm.get('organization').value;
    this.appointment.email = this.appointmentForm.get('email').value;
    this.appointment.official = this.appointmentForm.get('official').value;
    this.display = false;
    this.onSave.emit(this.appointment);
  }

  onStandardTitleChange(event) {
    if (event.value.official) {
      this.appointmentForm.get('official').setValue(event.value.official);
    }
  }

}
